var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","background-color":"white"}},[_c('van-image',{attrs:{"src":require('@/assets/common/error_pay.png'),"width":"30%","height":"20%"}}),_c('div',{attrs:{"id":"close"}},[_vm._v("支付失败请点击右上方返回游戏重新下单")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }